import { PORTAL_API_ROOT_URL } from './../constants';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { Invoice, InvoiceId, InvoiceDiscrepancy } from '@portal-front-end/models';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Update } from '@ngrx/entity';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class InvoiceApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly READ_INVOICE_API_URL = `${this.apiServer}/invoicing-view`;
    private readonly INVOICE_API_URL = `${this.apiServer}/invoicing`;
    private readonly INVOICE_DISCREPANCY_API_URL = `${this.apiServer}/invoicing-discrepancy`;

    // Get Invoice Discrepancy
    getInvoiceDiscrepancy(requestParams): Observable<InvoiceDiscrepancy[]> {
        return this.http.get<InvoiceDiscrepancy[]>(`${this.INVOICE_DISCREPANCY_API_URL}`, {
            params: {
                ...requestParams
            }
        });
    }

    getActiveInvoices(): Observable<Invoice[]> {
        return this.http.get<Invoice[]>(`${this.READ_INVOICE_API_URL}`, {
            params: {
                'statusId': '10'
            }
        });
    }

    getCompletedInvoices(requestParams): Observable<Invoice[]> {
        return this.http.get<Invoice[]>(`${this.INVOICE_API_URL}/search`, {
            params: {
                ...requestParams,
               // 'statusId': '40'
            }
        });
    }


    getInvoiceById(invoiceId: string): Observable<Invoice> {
        return this.http.get<Invoice[]>(`${this.READ_INVOICE_API_URL}`, {
            params: {
                'invoiceId': invoiceId
            }
        })
            .pipe(map(invoices => invoices[0]));
    }

    postInvoice(invoice: Invoice): Observable<Invoice> {
        return this.http.post<Invoice>(`${this.INVOICE_API_URL}/`, invoice);
    }

    putInvoiceById(payload: Update<Invoice>): Observable<Invoice> {
        return this.http.put<Invoice>(`${this.INVOICE_API_URL}/${payload.changes.invoiceId}`, payload.changes);
    }

    updateInvoice(invoice: Invoice): Observable<Invoice> {
        return this.http.put<Invoice>(`${this.INVOICE_API_URL}/${invoice.invoiceId}`, invoice);
    }

    reOcrInvoice(invoiceId: string): Observable<Invoice> {
        console.log(invoiceId);
        return this.http.post<Invoice>(`${this.INVOICE_API_URL}/re-ocr/${invoiceId}`, null);
    }

    archiveInvoice(invoice: Invoice): Observable<Invoice> {
        return this.http.post<Invoice>(`${this.INVOICE_API_URL}/archive/${invoice.invoiceId}`, null);
    }

    completeInvoice(invoiceId: string, forceFlag: boolean): Observable<Invoice> {
        return this.http.post<Invoice>(`${this.INVOICE_API_URL}/complete/${invoiceId}`, null, {
            params: {
                'force': String(forceFlag)
            }
        });
    }

    getInvoiceAttachment(uuid: string): Observable<HttpResponse<Blob>> {
        return this.http.get<Blob>(`${this.INVOICE_API_URL}/invoice-file`, {
            params: {
                'invoiceId': uuid
            },
            responseType: 'blob' as 'json',
            observe: 'response'
        });
    }

    attachInvoices() {
        return this.http.get(`${this.apiServer}/attach`);
    }
}
